module.exports = __webpack_public_path__ + "images/assets/9512a93719f8de8611e22e5fd68ed76a.svg";